import React, { useRef, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Link,
  Typography,
} from '@mui/material';
import Close from '@mui/icons-material/Close';
import PlayArrow from '@mui/icons-material/PlayArrow';
import { connect, useDispatch } from 'react-redux';

import { closeDialog } from '../../actions/dialog';

const NAVY = '#0D1B3E';
const RED = '#E63946';

const mapStateToProps = () => ({
  dialog: {
    contentProps: {
      badge,
      title,
      description,
      video,
      onSeen,
    },
  },
}) => ({
  badge,
  title,
  description,
  video,
  onSeen,
});

const DialogAnnouncement = ({
  badge,
  title,
  description,
  video,
  onSeen,
}) => {
  const dispatch = useDispatch();
  const [checked, setChecked] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const seenRef = useRef(false);

  const markSeenOnce = () => {
    if (!seenRef.current) {
      seenRef.current = true;
      onSeen();
    }
  };

  const dismiss = () => {
    if (checked) {
      markSeenOnce();
    }
    dispatch(closeDialog());
  };

  const watch = () => {
    markSeenOnce();
    setLightboxOpen(true);
  };

  return (
    <>
      <Box sx={{ position: 'relative', bgcolor: NAVY, p: 3, pt: 4 }}>
        <IconButton
          onClick={dismiss}
          sx={{ position: 'absolute', top: 8, right: 8, color: 'common.white' }}
        >
          <Close />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ flex: '1 1 auto', minWidth: 0 }}>
            <Box
              sx={{
                display: 'inline-block',
                bgcolor: RED,
                color: 'common.white',
                fontWeight: 700,
                fontSize: '0.75rem',
                px: 1.5,
                py: 0.5,
                borderRadius: 10,
                mb: 1.5,
              }}
            >
              {badge}
            </Box>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ color: 'common.white', mb: 1 }}
            >
              {title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'common.white' }}>
              {description}
            </Typography>
          </Box>
          <Box
            onClick={watch}
            sx={{
              position: 'relative',
              flex: '0 0 40%',
              maxWidth: 140,
              borderRadius: 2,
              overflow: 'hidden',
              cursor: 'pointer',
              lineHeight: 0,
            }}
          >
            <video
              src={video}
              muted
              playsInline
              preload="metadata"
              style={{
                width: '100%', display: 'block', pointerEvents: 'none',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'rgba(255, 255, 255, 0.85)',
                borderRadius: '50%',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <PlayArrow sx={{ color: RED }} fontSize="medium" />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ bgcolor: 'common.white', p: 3, textAlign: 'center' }}>
        <Button
          variant="contained"
          fullWidth
          startIcon={<PlayArrow />}
          onClick={watch}
          sx={{
            mb: 1.5,
            bgcolor: RED,
            color: 'common.white',
            '&:hover': { bgcolor: '#c8323e' },
          }}
        >
          Regarder la démo
        </Button>
        <Link
          component="button"
          type="button"
          onClick={dismiss}
          sx={{ display: 'block', mx: 'auto', mb: 1 }}
        >
          Plus tard
        </Link>
        <FormControlLabel
          control={(
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
          )}
          label="Ne plus afficher ce message"
        />
      </Box>
      {lightboxOpen && (
        <Box
          onClick={() => setLightboxOpen(false)}
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(0, 0, 0, 0.85)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <IconButton
            onClick={() => setLightboxOpen(false)}
            sx={{
              position: 'absolute',
              top: 16,
              right: 16,
              color: 'common.white',
            }}
          >
            <Close />
          </IconButton>
          <video
            src={video}
            controls
            autoPlay
            playsInline
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '90%', maxHeight: '90%' }}
          />
        </Box>
      )}
    </>
  );
};

export default connect(mapStateToProps)(DialogAnnouncement);
